export default __webpack_public_path__ + "static/media/2_0020.59563be7.webp";